import request from '@/util/request';
import qs from 'qs';

// 分页
export const getPageListApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/repository/information/file/page',
    Object.assign({}, options, { params })
  );

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/information/file/save', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const updateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/information/file/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const delApi = (params, options) =>
  request.post(
    '/api/v4ward/callcenter/repository/information/file/remove',
    qs.stringify(params),
    options
  );

// 详情
export const detailApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/repository/information/file/detail',
    Object.assign({}, options, { params })
  );

// 树-列表
export const treeListApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/repository/information/menu/lazyTree',
    Object.assign({}, options, { params })
  );

// 树-新增
export const treeAddApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/information/menu/save', params, options, {
    ContentType: 'application/json',
  });

// 树-修改
export const treeUpdateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/information/menu/update', params, options);

// 树-删除
export const treeDelApi = (params, options) =>
  request.post(
    '/api/v4ward/callcenter/repository/information/menu/remove',
    qs.stringify(params),
    options
  );
